export default __webpack_public_path__ + "static/media/encircledInfo.2a1ddf94.svg";